import { redirect as defaultRedirect } from '@tanstack/react-router'
import type { BeforeLoadParams } from './typings'

export function beforeLoad(
	{ context, location }: BeforeLoadParams,
	redirectFn: typeof defaultRedirect = defaultRedirect,
): void {
	const { auth } = context

	if (!auth) {
		// Auth-Kontext nicht vorhanden, wahrscheinlich weil OIDC nicht konfiguriert ist
		// → keine Auth-Prüfung nötig
		return
	}

	// Während des Ladevorgangs NICHT umleiten → sonst Race & Loop
	if (auth.isLoading) return

	if (!auth.isAuthenticated) {
		throw redirectFn({
			to: '/login',
			search: { to: location.href }, // gewünschte Ziel-URL mitgeben
		})
	}
}
